import { MapPin, Phone, Mail, MessageCircle, Clock } from "lucide-react";
import { useSettings } from "../hooks/useSettings";
import { EnquiryForm } from "../components/EnquiryForm";
import Seo from "../components/Seo";

const Contact = () => {
  const { data: s } = useSettings();
  const wa = (s?.whatsapp || "").replace(/[^0-9]/g, "");
  const AGENT = "https://customer-assets-wrfwihn1.emergentagent.net/job_satyam-homes-jaipur/artifacts/e786y77m_IMG-20180329-WA0015.JPG";

  const cards = [
    { icon: MessageCircle, label: "WhatsApp", value: "Chat with us", href: `https://wa.me/${wa}`, accent: true },
    { icon: Phone, label: "Call", value: s?.phone, href: `tel:${s?.phone}` },
    { icon: Mail, label: "Email", value: s?.email, href: `mailto:${s?.email}` },
    { icon: MapPin, label: "Office", value: s?.address },
  ];

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
      <Seo title="Contact Satyam Real Estate — Property Experts in Jaipur"
        description="Get in touch with Satyam Real Estate. Call, WhatsApp or email us for property enquiries across Jaipur." />
      <div className="grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand">Contact Us</span>
          <h1 className="font-heading text-4xl sm:text-5xl text-stone-900 mt-3">Let's find your next property</h1>
          <p className="text-stone-600 mt-4 max-w-md">
            Tell us what you're looking for and where. Our team knows Jaipur's neighbourhoods inside out and will guide you to the right options.
          </p>
          <div className="grid sm:grid-cols-2 gap-4 mt-10">
            {cards.map((c) => {
              const Wrap = c.href ? "a" : "div";
              return (
                <Wrap key={c.label} {...(c.href ? { href: c.href, target: c.href.startsWith("http") ? "_blank" : undefined, rel: "noreferrer" } : {})}
                  data-testid={`contact-${c.label.toLowerCase()}`}
                  className={`rounded-2xl border p-5 transition-colors ${c.accent ? "bg-[#25D366] text-white border-[#25D366]" : "bg-white border-stone-200 hover:border-brand"}`}>
                  <c.icon className={c.accent ? "text-white" : "text-brand"} size={24} />
                  <p className={`text-xs uppercase tracking-wider mt-3 ${c.accent ? "text-white/80" : "text-stone-500"}`}>{c.label}</p>
                  <p className={`font-semibold mt-0.5 break-words ${c.accent ? "text-white" : "text-stone-800"}`}>{c.value}</p>
                </Wrap>
              );
            })}
          </div>
          <div className="flex items-center gap-2 mt-8 text-sm text-stone-500">
            <Clock size={16} className="text-brand" /> Open Mon–Sat, 10:00 AM – 7:00 PM
          </div>
        </div>
        <div className="relative rounded-3xl overflow-hidden aspect-[4/5] max-w-md w-full mx-auto">
          <img src={AGENT} alt="Satyam Real Estate agent" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          <div className="absolute bottom-0 p-7 text-white">
            <p className="font-heading text-2xl">{s?.firm_name}</p>
            <p className="text-white/80 text-sm mt-1">{s?.tagline}</p>
          </div>
        </div>
      </div>

      <div className="mt-16 max-w-2xl">
        <h2 className="font-heading text-3xl text-stone-900 mb-2">Post your requirement</h2>
        <p className="text-stone-500 mb-6">Share what you're looking for and we'll get back to you shortly.</p>
        <div className="bg-white rounded-2xl border border-stone-200 p-6">
          <EnquiryForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
